import ShopNowReturnCredit from '~/app/features/crew/shop-now/ShopNowReturnCredit';
import ShopNowSteps from '~/app/features/crew/shop-now/ShopNowSteps';
import Button from '~/components/Button';
import Card from '~/components/Card';
import Form from '~/components/Form';
import Page from '~/components/Page';
import { useIsLoading } from '~/utils/routing';
import { useLoaderData } from './shopNowStart';

const shopNowSteps = [
  {
    icon: 'ArrowRight' as const,
    title: 'Start Shopping',
    description:
      'Click the "Start Shopping" button below to be directed to our store.',
  },
  {
    icon: 'MagnifyingGlass' as const,
    title: 'Browse & Add to Cart',
    description:
      'Browse and select your new items. Add them to your cart as usual.',
  },
  {
    icon: 'CheckCircle' as const,
    title: 'Continue with Return',
    description:
      'When you\'re ready to checkout, click "Continue with return" in the cart to complete your return.',
  },
];

// TODO: SHOP NOW refine instructions / define content and images
export default function ShopStartPage() {
  const isLoading = useIsLoading();
  const { credit, incentive } = useLoaderData();

  return (
    <Page headline="Shop Now Instructions" hideHeader>
      <Card headline="Ready, set, Shop now!" hideHeader>
        <ShopNowReturnCredit credit={credit} incentive={incentive} />
        <ShopNowSteps steps={shopNowSteps} />

        <Form className="mt-8">
          <Button
            type="submit"
            className="md:w-1/2"
            disabled={isLoading}
            name="shopNow"
            value="yes"
          >
            Start Shopping
          </Button>
        </Form>
      </Card>
    </Page>
  );
}
